import { authenticatedJsonFetch } from '@perpay-web/authentication/authenticatedJsonFetch';
import { HTTPMethod } from '@perpay-web/constants/httpMethods';
import { useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import {
    submitCardMigration,
    submitCardMigrationSuccess,
    submitCardMigrationError,
    submitCardMigrationReset,
} from '@perpay-web/fintech/actions/ui/cardMigration';
import { CARD_ACCOUNT_MIGRATE_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const useSubmitCardMigrationDataModule = () => {
    const dataModule = useDataModule(({ uuid, material, validatedAddress }) =>
        authenticatedJsonFetch(
            CARD_ACCOUNT_MIGRATE_ENDPOINT.replace(':uuid', uuid),
            { material, validatedAddress },
            HTTPMethod.patch,
        ),
    );

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: submitCardMigration,
        success: submitCardMigrationSuccess,
        error: submitCardMigrationError,
        reset: submitCardMigrationReset,
    });

    return dataModule;
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useSubmitCardMigrationDataModule();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    UseSubmitCardMigrationDataModuleProvider,
    useSubmitCardMigrationContext,
] = createContextProvider(providerFactory);
